/**@private
    *Get items from HTML5 Local Storage
    *@param {String} name Name of the local storage item to retrieve
    *@return {String} html local / session storage
    */
export function getLocalStorageItem(name) {
    let storedItem;
    try {
        storedItem = window.localStorage[name];
        if (storedItem === null) {
            storedItem = window.sessionStorage[name];
        }
    } catch { }
    return storedItem;
}

/**@private
 *Get the first party site cookie name
 *@return {String} cookiename + sitename
 */
export function getSiteCookie(cookieName, sitename) {
    return (cookieName + "_" + sitename).toLowerCase();
}

/**@private
  *Read cookies
  *@param {String} name The name of the cookie / storage item to retrieve
  *@return {String} cookie/local storage data*/
export function readCookie(name) {
    let nameEQ = name + "=",
        cookieArr = document.cookie.split(';');

    for (let i = 0; i < cookieArr.length; i++) {
        let cookieStr = cookieArr[i];
        while (cookieStr.charAt(0) === ' ') {
            cookieStr = cookieStr.substring(1, cookieStr.length);
        }
        if (cookieStr.indexOf(nameEQ) === 0) {
            return cookieStr.substring(nameEQ.length, cookieStr.length);
        }
    }

    getLocalStorageItem(name);
}

export function getSessionStorageItem(name) {
    var storedItem = null;

    if (window.sessionStorage[name]!=null) {
        storedItem = window.sessionStorage[name];
    }
    return storedItem;
}


export function addSessionStorageItem(name,value) {
    window.sessionStorage[name] = value;
}

export function removeSessionStorageItem(name) {
    if (window.sessionStorage[name] != null) {
        window.sessionStorage.removeItem(name);
    }
}